import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const connectionPropertiesMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Connection Properties',
		isVisible: ({ refMap }): boolean => {
			// const panel = ui.pointer.context.ref as Panel;
			// const { island } = panel.refMap;
			const { panel, island, obstruction } = refMap;
			const sourceIsland = island || obstruction;
			if (!sourceIsland) return false;

			const obstructionPanel = obstruction ? obstruction.frontPanel : null;
			const connection = sourceIsland.connections.getConnectionsBySourcePanelId(panel?.id ?? obstructionPanel?.id);
			// console.log('isVisiable', panel.label, connection);
			return connection.length === 1;
		},
		onClick: ({ context, controller }): void => {
			controller.publishShowProperties('connection', context.id);
		}
	}
};
